import { render, staticRenderFns } from "./headerBackground.vue?vue&type=template&id=208b49ea&scoped=true"
import script from "./headerBackground.vue?vue&type=script&lang=ts"
export * from "./headerBackground.vue?vue&type=script&lang=ts"
import style0 from "./headerBackground.vue?vue&type=style&index=0&id=208b49ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b49ea",
  null
  
)

export default component.exports